import './style.scss';

import React from 'react';

import DiscountDetails from './DiscountDetails/DiscountDetails';
import SumDetails from './SumDetails/SumDetails';
import { PriceCardProps } from './Types';

export const PriceCard: React.FC<PriceCardProps> = (props: PriceCardProps) => {
  return (
    <div>
      <SumDetails
        descriptionTitle={props.descriptionTitle} //"Du har valt"
        title={props.title} //"Helförsäkring + Pluspaket"
        price={props.price} //430 kr
        period={props.period} //per månad
        isPriceLoading={props.isPriceLoading}
        priceLabel={props.priceLabel}
      />
      {props.discountsList && props.discountsList?.length > 0 && (
        <DiscountDetails
          totalDiscountTitle={props.totalDiscountTitle} //Din totala rabatt
          totalDiscountYearly={props.totalDiscountYearly} //295 kr per år
          isPriceLoading={props.isPriceLoading}
          discountsList={props.discountsList}
        />
      )}
    </div>
  );
};
